import dayjs from 'dayjs';

export class MockedVitodens343FFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes',
      },
      {
        properties: {
          value: {
            value: 47.2,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.outlet',
        timestamp: '2020-02-26T06:59:13.099Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.outlet',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.forcedNormal',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.forcedNormal',
      },
      {
        properties: {
          value: {
            value: 52.1,
            type: 'number',
            unit: 'celsius',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2020-02-26T06:55:30.468Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.standby',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.standby',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '04:30',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '04:30',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '04:30',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '04:30',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '04:30',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '06:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '06:00',
                  end: '24:00',
                  mode: 'on',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.pumps.circulation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation.schedule',
        timestamp: '2020-02-26T02:38:35.155Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation.schedule',
      },
      {
        properties: {
          value: {
            value: 13.8,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature.dhw',
        timestamp: '2020-02-26T05:54:03.220Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature.dhw',
      },
      {
        properties: {
          value: {
            value: 60,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2020-02-26T02:38:35.049Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
      },
      {
        properties: {
          value: {
            value: 42,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2020-02-26T06:59:25.416Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
      },
      {
        properties: {
          hours: {
            value: 1479,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.statistics',
        timestamp: '2020-02-26T02:38:35.003Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.statistics',
      },
      {
        properties: {
          value: {
            value: 4.6,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature.collector',
        timestamp: '2020-02-26T07:00:07.696Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature.collector',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating',
      },
      {
        properties: {
          value: {
            value: 45,
            type: 'number',
            unit: 'percent',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.modulation',
        timestamp: '2020-02-26T07:00:05.337Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.modulation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.forcedReduced',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.forcedReduced',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.dhw',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.dhw',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.primary',
        timestamp: '2020-02-26T06:42:30.183Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.primary',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.power',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.power',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.dhw.pumps',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.dhw.pumps',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.pumps',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.pumps',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.dhw',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.dhw',
      },
      {
        properties: {
          enabled: {
            value: ['0', '1'],
            type: 'array',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2020-02-26T02:38:35.045Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2020-02-26T05:36:32.836Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.dhw',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.external',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.external',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 0,
          },
          slope: {
            type: 'number',
            value: 0.8,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2020-02-26T02:38:34.993Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.dhw.pumps.circulation',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.dhw.pumps.circulation',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '05:30',
                  end: '22:00',
                  mode: 'on',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2020-02-26T02:38:35.060Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
      },
      {
        properties: {
          value: {
            value: 'dhwAndHeating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'dhw', 'dhwAndHeating', 'forcedReduced', 'forcedNormal'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.active',
        timestamp: '2020-02-26T02:38:35.115Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.active',
      },
      {
        properties: {
          value: {
            value: 35.5,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.supply',
        timestamp: '2020-02-26T06:58:45.228Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.supply',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.external',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.external',
      },
      {
        properties: {
          value: {
            value: 5108,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.power.cumulativeProduced',
        timestamp: '2020-02-26T02:38:39.541Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.power.cumulativeProduced',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.forcedReduced',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.forcedReduced',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.charging',
        timestamp: '2020-02-26T06:41:29.509Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.charging',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [
                {
                  timestamp: '2020-02-21T11:56:55.000Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-20T15:19:25.000Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-20T01:47:58.000Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:31:04.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:28:52.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:26:39.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:24:25.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-02-24T08:12:55.000Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-02-24T07:43:50.000Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-02-23T05:51:24.000Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
              current: [
                {
                  timestamp: '2020-02-21T11:56:55.000Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-20T15:19:25.000Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-20T01:47:58.000Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:31:04.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:28:52.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:26:39.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-08-28T13:24:25.000Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-02-24T08:12:55.000Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-02-24T07:43:50.000Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2018-02-23T05:51:24.000Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
              gone: [
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'eb',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'ee',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-26T02:38:38.041Z',
                  errorCode: 'f2',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.history',
        timestamp: '2020-02-26T03:38:45.101Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.history',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.room',
        timestamp: '2020-02-26T02:38:35.003Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.room',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burner.current',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burner.current',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndHeating',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndHeating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.dhw.pumps',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.dhw.pumps',
      },
      {
        properties: {
          day: {
            value: [18, 76, 84, 58, 77, 43, 11, 45],
            type: 'array',
          },
          week: {
            value: [
              170,
              300,
              501,
              292,
              495,
              682,
              438,
              495,
              526,
              479,
              382,
              453,
              452,
              378,
              0,
              356,
              409,
              277,
              524,
              192,
              109,
              222,
              261,
              14,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              12,
              20,
              105,
              133,
              126,
              43,
              252,
              375,
              247,
              406,
              466,
              518,
              397,
            ],
            type: 'array',
          },
          month: {
            value: [1333, 2423, 1967, 1544, 1099, 41, 0, 0, 0, 365, 948, 1991, 2176],
            type: 'array',
          },
          year: {
            value: [3756, 13088, 17006],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.heating',
        timestamp: '2020-02-26T06:58:48.296Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.dhw.pumps.circulation',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.dhw.pumps.circulation',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2020-02-26T05:36:32.836Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
      },
      {
        properties: {
          hours: {
            value: 9793,
            type: 'number',
            unit: 'hours',
          },
          starts: {
            value: 12075,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.statistics',
        timestamp: '2020-02-26T06:49:30.489Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.statistics',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'Heizkreis 1',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2020-02-26T02:38:34.991Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.power',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.eco/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.eco/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.eco',
        timestamp: '2020-02-26T05:36:37.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.eco',
      },
      {
        properties: {
          value: {
            value: 60,
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature',
        timestamp: '2020-02-26T02:38:34.991Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2020-02-26T02:38:35.003Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
      },
      {
        properties: {
          value: {
            value: '7570953-device-serial',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2020-02-26T02:38:34.991Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors',
      },
      {
        properties: {
          value: {
            value: 42,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.main',
        timestamp: '2020-02-26T06:59:25.345Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.main',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2020-02-26T02:38:34.993Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.pumps.circuit',
        timestamp: '2020-02-26T02:38:35.003Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.pumps.circuit',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler',
        timestamp: '2020-02-26T02:38:34.574Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.service',
        timestamp: '2020-02-26T02:38:34.574Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.holiday',
        timestamp: '2020-02-26T02:38:35.001Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.holiday',
      },
      {
        properties: {
          value: {
            value: 3.3,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2020-02-26T06:50:21.221Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.frostprotection',
        timestamp: '2020-02-26T02:38:35.005Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.frostprotection',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.oneTimeCharge',
        timestamp: '2020-02-26T02:38:35.002Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.oneTimeCharge',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating',
        timestamp: '2020-02-26T02:38:34.574Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating',
      },
      {
        properties: {
          activeMonthSinceLastService: {
            value: 0,
            type: 'number',
          },
          serviceIntervalMonths: {
            value: 0,
            type: 'number',
          },
          lastService: {
            value: '',
            type: 'string',
          },
          serviceDue: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.service.timeBased',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.service.timeBased',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndHeating',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndHeating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.circulation',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.circulation',
      },
      {
        properties: {
          day: {
            value: [0.5, 1.2, 0.2, 0, 0, 0, 0, 0],
            type: 'array',
          },
          week: {
            value: [1.9, 0, 0, 0, 0],
            type: 'array',
          },
          month: {
            value: [2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          year: {
            value: [2, 0],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: '7782093-gw-serial',
        feature: 'heating.power.consumption.heating',
        timestamp: '2020-05-07T05:53:00.836Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.heating',
      },
      {
        properties: {
          day: {
            value: [0, 0.1, 0.3, 0, 0, 0, 0, 0],
            type: 'array',
          },
          week: {
            value: [0.4, 0, 0, 0, 0],
            type: 'array',
          },
          month: {
            value: [0.5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          year: {
            value: [0.5, 0],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: '7782093-gw-serial',
        feature: 'heating.power.consumption.dhw',
        timestamp: '2020-05-06T23:22:08.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.dhw',
      },
      {
        properties: {
          day: {
            value: [0.5, 1.3, 0.5, 0, 0, 0, 0, 0],
            type: 'array',
          },
          week: {
            value: [2.3, 0, 0, 0, 0],
            type: 'array',
          },
          month: {
            value: [2.5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            type: 'array',
          },
          year: {
            value: [2.5, 0],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: '7782093-gw-serial',
        feature: 'heating.power.consumption.total',
        timestamp: '2020-05-07T05:53:00.924Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.total',
      },
      {
        properties: {
          status: {
            value: 'ok',
            type: 'string',
          },
          errorCode: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.errorStatus',
        timestamp: '2020-02-26T02:38:34.992Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.errorStatus',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2020-02-26T02:38:35.002Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.active',
        timestamp: '2020-02-26T05:36:37.233Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.active',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.room',
        timestamp: '2020-02-26T02:38:35.002Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.room',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2020-02-26T02:38:34.993Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2020-02-21T16:54:07.945Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 4,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 4,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2020-02-26T02:38:34.992Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
      },
      {
        properties: {
          value: {
            value: '7661464701571100',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.controller.serial',
        timestamp: '2020-02-26T02:38:35.002Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.controller.serial',
      },
      {
        properties: {
          value: {
            value: 'dhwAndHeating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'dhw', 'dhwAndHeating', 'forcedReduced', 'forcedNormal'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2020-02-26T02:38:35.115Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2020-02-26T05:36:32.812Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.holiday',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 18,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reduced',
        timestamp: '2020-02-26T05:36:37.191Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reduced',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.eco',
        timestamp: '2020-02-26T05:36:32.827Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.eco',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.pump',
        timestamp: '2020-02-26T06:42:39.044Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.pump',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 4,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 4,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfort',
        timestamp: '2020-02-26T02:38:34.992Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfort',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhw',
        timestamp: '2020-02-26T02:38:35.005Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.controller',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.controller',
      },
      {
        properties: {
          value: {
            value: 0,
            type: 'number',
          },
          top: {
            value: 0,
            type: 'number',
          },
          middle: {
            value: 0,
            type: 'number',
          },
          bottom: {
            value: 0,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.charging.level',
        timestamp: '2020-02-26T02:38:35.005Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.charging.level',
      },
      {
        properties: {
          value: {
            value: 8,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burner.current.power',
        timestamp: '2020-02-26T06:58:16.810Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burner.current.power',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhw',
        timestamp: '2020-02-26T02:38:35.005Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors',
        timestamp: '2020-02-26T02:38:34.574Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation.pump',
        timestamp: '2020-02-26T06:42:42.238Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation.pump',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.forcedNormal',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.forcedNormal',
      },
      {
        properties: {
          value: {
            value: 24,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2020-02-26T03:38:45.097Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.rechargeSuppression',
        timestamp: '2020-02-26T02:38:35.004Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.rechargeSuppression',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [1.53, 6.4, 2.51, 1.09, 12.7, 10.8, 9.8, 4.3],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.power.production',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.power.production',
        timestamp: '2023-03-14T08:28:45.972Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 1,
          },
          slope: {
            type: 'number',
            value: 0.8,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.curve',
        timestamp: '2020-02-26T02:38:34.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.curve',
      },
      {
        properties: {
          value: {
            value: 46.3,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.temperature',
        timestamp: '2020-02-26T06:52:38.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.dhw.pumps',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.dhw.pumps',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2020-02-26T02:38:35.003Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
      },
      {
        properties: {
          day: {
            value: [7, 23, 24, 29, 24, 23, 17, 24],
            type: 'array',
          },
          week: {
            value: [
              47,
              174,
              192,
              188,
              178,
              196,
              187,
              189,
              227,
              194,
              224,
              208,
              202,
              217,
              0,
              192,
              197,
              181,
              195,
              161,
              163,
              168,
              161,
              147,
              135,
              116,
              96,
              66,
              69,
              88,
              76,
              79,
              56,
              87,
              98,
              86,
              51,
              66,
              67,
              67,
              99,
              91,
              113,
              122,
              132,
              118,
              103,
              155,
              132,
              152,
              149,
              164,
              165,
            ],
            type: 'array',
          },
          month: {
            value: [656, 864, 929, 837, 736, 523, 331, 364, 285, 488, 543, 718, 726],
            type: 'array',
          },
          year: {
            value: [1520, 7410, 2673],
            type: 'array',
          },
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.dhw',
        timestamp: '2020-02-26T06:18:47.894Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating',
        timestamp: '2020-02-26T02:38:34.574Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs',
        timestamp: '2020-02-26T02:38:34.574Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '06:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.schedule',
        timestamp: '2020-02-26T02:38:34.993Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.dhw.pumps.circulation',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.dhw.pumps.circulation',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0',
        timestamp: '2020-02-26T06:48:34.553Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normal',
        timestamp: '2020-02-26T05:36:37.233Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normal',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature',
        timestamp: '2020-02-26T02:38:34.575Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.standby',
        timestamp: '2020-02-26T02:38:35.001Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.standby',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'Heizkreis 2',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1',
        timestamp: '2020-02-26T02:38:34.992Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:00:22.905Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:00:22.905Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.geofencing',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T07:00:22.906Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.geofencing',
      },
    ];
  }
}
